import { isLayerWithQuery } from "./layer.js";
import * as Fronto from "./utility.js";

export async function InteractionTransformation(role, spec, original, specifier, action, option) {
  if (option?.interaction === "context" && action === "add") {
    if (spec.interaction === undefined) spec.interaction = {}
    spec.interaction.context = {
      "height": (option.height !== undefined ? option.height : 150)
    }
    delete spec.interaction.zoompan;
  } else if ((option?.interaction === "context" || specifier.interaction === "context") && action === "remove") {
    delete spec.interaction?.context;
  } else if ((option?.interaction === "context" || specifier.interaction === "context") && action === "modify") {
    if (spec.interaction?.context) {
      if (option.height !== undefined) {
        spec.interaction.context.height = option.height;
      }
    }
  } else if (option?.interaction === "zoompan" && action === "add") {
    if (spec.interaction === undefined) spec.interaction = {}
    spec.interaction.zoompan = true;
    delete spec.interaction.context;
  } else if ((option?.interaction === "zoompan" || specifier.interaction === "zoompan") && action === "remove") {
    delete spec.interaction?.zoompan;
  } else if (option.interaction === "filter") {
    if (action === "modify") {
      if (spec.interaction === undefined) spec.interaction = {};
      if (option.field) {
        spec.interaction.filter = option.field;
      };
    }
  }
  return spec;
}

export async function TooltipTransformation(role, spec, original, specifier, action, option) {
  spec.layer.forEach((layerItem, li) => {
    let flag = isLayerWithQuery(layerItem, li, specifier.mark, specifier.layer.index, specifier.layer.id);
    if (flag) { // more query (todo)
      if (action === "reposition" || action === "modify") {
        if (option?.external && option?.fixed) {
          // let fixPosition = option?.position || "bottom";
          layerItem.tooltip.visibility = "fixed";
        } else if (option?.external == false && option?.fixed == false) {
          layerItem.tooltip.visibility = "on-mark";
        }

        if (option?.hidden) {
          layerItem.tooltip.visibility = "hidden";
        }

        if (option?.fields) {
          layerItem.tooltip.fields = option.fields;
        }
      } else if (action === "remove") {
        delete layerItem.tooltip;
      } else if (action === "replace") {
        if (option?.to?.layer !== undefined && layerItem.tooltip) {
          let tooltip = Fronto.deepcopy(layerItem.tooltip);
          delete layerItem.tooltip;
          let layerName = option.to.layer.id, layerIndex = option.to.layer.index, layerMark = option.to.layer.mark;
          spec.layer.forEach((layerToCopy, li2) => {
            if (isLayerWithQuery(layerToCopy, li2, layerMark, layerIndex, layerName)) {
              layerToCopy.tooltip = tooltip;
            }
          });
        }
      }
    }
  })
  return spec;
}